const POSSIBLE_FONT_WEIGHT_OPTIONS = [
  {
    icon: 'bold',
    value: 100,
    label: 'Thin, Hairline',
    style: { fontWeight: '100' },
  },
  {
    icon: 'bold',
    value: 200,
    label: 'Extra Light',
    style: { fontWeight: '200' },
  },
  {
    icon: 'bold',
    value: 300,
    label: 'Light',
    style: { fontWeight: '300' },
  },
  {
    icon: 'bold',
    value: 400,
    label: 'Regular, Book',
    style: { fontWeight: '400' },
  },
  {
    icon: 'bold',
    value: 500,
    label: 'Medium',
    style: { fontWeight: '500' },
  },
  {
    icon: 'bold',
    value: 600,
    label: 'Semi Bold',
    style: { fontWeight: '600' },
  },
  {
    icon: 'bold',
    value: 700,
    label: 'Bold',
    style: { fontWeight: '700' },
  },
  {
    icon: 'bold',
    value: 800,
    label: 'Extra Bold',
    style: { fontWeight: '800' },
  },
  {
    icon: 'bold',
    value: 900,
    label: 'Black, Heavy',
    style: { fontWeight: '900' },
  },
];

/*
  {
    fontFamily: 'FONT_FAM',
    fontPath: '/assets/fonts/customer/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'FONT_FAM-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'FONT_FAM-Extralight', local: [] },
      { style: 'normal', weight: '300', file: 'FONT_FAM-Light', local: [] },
      { style: 'normal', weight: '400', file: 'FONT_FAM-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'FONT_FAM-Medium', local: [] },
      { style: 'normal', weight: '600', file: 'FONT_FAM-SemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'FONT_FAM-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'FONT_FAM-ExtraBold', local: [] },
      { style: 'normal', weight: '900', file: 'FONT_FAM-Black', local: [] },
      { style: 'italic', weight: '100', file: 'FONT_FAM-ThinItalic', local: [] },
      { style: 'italic', weight: '200', file: 'FONT_FAM-ExtralightItalic', local: [] },
      { style: 'italic', weight: '300', file: 'FONT_FAM-LightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'FONT_FAM-RegularItalic', local: [] },
      { style: 'italic', weight: '500', file: 'FONT_FAM-MediumItalic', local: [] },
      { style: 'italic', weight: '600', file: 'FONT_FAM-SemiBoldItalic', local: [] },
      { style: 'italic', weight: '700', file: 'FONT_FAM-BoldItalic', local: [] },
      { style: 'italic', weight: '800', file: 'FONT_FAM-ExtraBoldItalic', local: [] },
      { style: 'italic', weight: '900', file: 'FONT_FAM-BlackItalic', local: [] },
    ],
  },
*/

// 100 - Thin, Hairline
// 200 - Extra Light, Ultra Light
// 300 - Light
// 400 - Normal, Regular
// 500 - Medium
// 600 - Semi Bold, Demi Bold
// 700 - Bold
// 800 - Extra Bold, Ultra Bold
// 900 - Black, Heavy
const FONT_CONFIG = [
  // Google Fonts
  {
    fontFamily: 'Barlow',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'barlow-v12-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'barlow-v12-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'barlow-v12-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'barlow-v12-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'barlow-v12-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'barlow-v12-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'barlow-v12-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'barlow-v12-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'barlow-v12-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'barlow-v12-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'barlow-v12-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'barlow-v12-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'barlow-v12-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'barlow-v12-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'barlow-v12-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'barlow-v12-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'barlow-v12-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'barlow-v12-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Black Ops One',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'black-ops-one-v20-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Bungee Shade',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'bungee-shade-v15-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Cabin',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'cabin-v27-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'cabin-v27-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'cabin-v27-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'cabin-v27-latin-700', local: [] },
      { style: 'italic', weight: '400', file: 'cabin-v27-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'cabin-v27-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'cabin-v27-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'cabin-v27-latin-700italic', local: [] },
    ],
  },
  {
    fontFamily: 'Cormorant',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'cormorant-v21-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'cormorant-v21-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'cormorant-v21-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'cormorant-v21-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'cormorant-v21-latin-700', local: [] },
      { style: 'italic', weight: '300', file: 'cormorant-v21-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'cormorant-v21-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'cormorant-v21-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'cormorant-v21-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'cormorant-v21-latin-700italic', local: [] },
    ],
  },
  {
    fontFamily: 'Creepster',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'creepster-v13-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Dosis',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'dosis-v32-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'dosis-v32-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'dosis-v32-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'dosis-v32-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'dosis-v32-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'dosis-v32-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'dosis-v32-latin-800', local: [] },
    ],
  },
  {
    fontFamily: 'Eczar',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'eczar-v22-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'eczar-v22-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'eczar-v22-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'eczar-v22-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'eczar-v22-latin-800', local: [] },
    ],
  },
  {
    fontFamily: 'Encode Sans Expanded',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'encode-sans-expanded-v11-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'encode-sans-expanded-v11-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'encode-sans-expanded-v11-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'encode-sans-expanded-v11-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'encode-sans-expanded-v11-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'encode-sans-expanded-v11-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'encode-sans-expanded-v11-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'encode-sans-expanded-v11-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'encode-sans-expanded-v11-latin-900', local: [] },
    ],
  },
  {
    fontFamily: 'Encode Sans',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'encode-sans-v19-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'encode-sans-v19-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'encode-sans-v19-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'encode-sans-v19-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'encode-sans-v19-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'encode-sans-v19-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'encode-sans-v19-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'encode-sans-v19-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'encode-sans-v19-latin-900', local: [] },
    ],
  },
  {
    fontFamily: 'Ewert',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'ewert-v25-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Exo',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'exo-v21-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'exo-v21-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'exo-v21-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'exo-v21-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'exo-v21-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'exo-v21-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'exo-v21-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'exo-v21-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'exo-v21-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'exo-v21-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'exo-v21-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'exo-v21-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'exo-v21-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'exo-v21-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'exo-v21-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'exo-v21-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'exo-v21-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'exo-v21-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Exo 2',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'exo-2-v24-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'exo-2-v24-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'exo-2-v24-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'exo-2-v24-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'exo-2-v24-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'exo-2-v24-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'exo-2-v24-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'exo-2-v24-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'exo-2-v24-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'exo-2-v24-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'exo-2-v24-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'exo-2-v24-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'exo-2-v24-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'exo-2-v24-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'exo-2-v24-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'exo-2-v24-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'exo-2-v24-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'exo-2-v24-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Fira Sans',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'fira-sans-v17-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'fira-sans-v17-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'fira-sans-v17-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'fira-sans-v17-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'fira-sans-v17-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'fira-sans-v17-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'fira-sans-v17-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'fira-sans-v17-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'fira-sans-v17-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'fira-sans-v17-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'fira-sans-v17-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'fira-sans-v17-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'fira-sans-v17-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'fira-sans-v17-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'fira-sans-v17-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'fira-sans-v17-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'fira-sans-v17-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'fira-sans-v17-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Fredericka the Great',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'fredericka-the-great-v21-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Hanken Grotesk',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'hanken-grotesk-v8-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'hanken-grotesk-v8-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'hanken-grotesk-v8-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'hanken-grotesk-v8-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'hanken-grotesk-v8-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'hanken-grotesk-v8-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'hanken-grotesk-v8-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'hanken-grotesk-v8-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'hanken-grotesk-v8-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'hanken-grotesk-v8-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'hanken-grotesk-v8-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'hanken-grotesk-v8-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'hanken-grotesk-v8-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'hanken-grotesk-v8-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'hanken-grotesk-v8-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'hanken-grotesk-v8-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'hanken-grotesk-v8-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'hanken-grotesk-v8-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'IBM Plex Mono',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'ibm-plex-mono-v19-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'ibm-plex-mono-v19-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'ibm-plex-mono-v19-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'ibm-plex-mono-v19-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'ibm-plex-mono-v19-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'ibm-plex-mono-v19-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'ibm-plex-mono-v19-latin-700', local: [] },
      { style: 'italic', weight: '100', file: 'ibm-plex-mono-v19-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'ibm-plex-mono-v19-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'ibm-plex-mono-v19-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'ibm-plex-mono-v19-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'ibm-plex-mono-v19-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'ibm-plex-mono-v19-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'ibm-plex-mono-v19-latin-700italic', local: [] },
    ],
  },
  {
    fontFamily: 'IBM Plex Sans',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'ibm-plex-sans-v21-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'ibm-plex-sans-v21-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'ibm-plex-sans-v21-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'ibm-plex-sans-v21-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'ibm-plex-sans-v21-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'ibm-plex-sans-v21-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'ibm-plex-sans-v21-latin-700', local: [] },
      { style: 'italic', weight: '100', file: 'ibm-plex-sans-v21-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'ibm-plex-sans-v21-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'ibm-plex-sans-v21-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'ibm-plex-sans-v21-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'ibm-plex-sans-v21-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'ibm-plex-sans-v21-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'ibm-plex-sans-v21-latin-700italic', local: [] },
    ],
  },
  {
    fontFamily: 'Indie Flower',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'indie-flower-v22-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Inter',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'inter-v18-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'inter-v18-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'inter-v18-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'inter-v18-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'inter-v18-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'inter-v18-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'inter-v18-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'inter-v18-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'inter-v18-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'inter-v18-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'inter-v18-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'inter-v18-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'inter-v18-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'inter-v18-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'inter-v18-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'inter-v18-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'inter-v18-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'inter-v18-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Inter Tight',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'inter-tight-v7-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'inter-tight-v7-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'inter-tight-v7-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'inter-tight-v7-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'inter-tight-v7-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'inter-tight-v7-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'inter-tight-v7-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'inter-tight-v7-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'inter-tight-v7-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'inter-tight-v7-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'inter-tight-v7-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'inter-tight-v7-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'inter-tight-v7-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'inter-tight-v7-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'inter-tight-v7-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'inter-tight-v7-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'inter-tight-v7-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'inter-tight-v7-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Istok Web',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'istok-web-v24-latin-regular', local: [] },
      { style: 'normal', weight: '700', file: 'istok-web-v24-latin-700', local: [] },
      { style: 'italic', weight: '400', file: 'istok-web-v24-latin-italic', local: [] },
      { style: 'italic', weight: '700', file: 'istok-web-v24-latin-700italic', local: [] },
    ],
  },
  {
    fontFamily: 'Lacquer',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'lacquer-v15-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Lato',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'lato-v24-latin-100', local: [] },
      { style: 'normal', weight: '300', file: 'lato-v24-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'lato-v24-latin-regular', local: [] },
      { style: 'normal', weight: '700', file: 'lato-v24-latin-700', local: [] },
      { style: 'normal', weight: '900', file: 'lato-v24-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'lato-v24-latin-100italic', local: [] },
      { style: 'italic', weight: '300', file: 'lato-v24-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'lato-v24-latin-italic', local: [] },
      { style: 'italic', weight: '700', file: 'lato-v24-latin-700italic', local: [] },
      { style: 'italic', weight: '900', file: 'lato-v24-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'League Spartan',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'league-spartan-v11-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'league-spartan-v11-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'league-spartan-v11-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'league-spartan-v11-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'league-spartan-v11-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'league-spartan-v11-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'league-spartan-v11-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'league-spartan-v11-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'league-spartan-v11-latin-900', local: [] },
    ],
  },
  {
    fontFamily: 'Libre Barcode 128 Text',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'libre-barcode-128-text-v29-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Lobster',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'lobster-v30-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Lora',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'lora-v35-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'lora-v35-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'lora-v35-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'lora-v35-latin-700', local: [] },
      { style: 'italic', weight: '400', file: 'lora-v35-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'lora-v35-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'lora-v35-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'lora-v35-latin-700italic', local: [] },
    ],
  },
  {
    fontFamily: 'Major Mono Display',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'major-mono-display-v16-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Manrope',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'manrope-v15-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'manrope-v15-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'manrope-v15-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'manrope-v15-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'manrope-v15-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'manrope-v15-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'manrope-v15-latin-800', local: [] },
    ],
  },
  {
    fontFamily: 'Merriweather Sans',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'merriweather-sans-v26-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'merriweather-sans-v26-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'merriweather-sans-v26-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'merriweather-sans-v26-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'merriweather-sans-v26-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'merriweather-sans-v26-latin-800', local: [] },
      { style: 'italic', weight: '300', file: 'merriweather-sans-v26-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'merriweather-sans-v26-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'merriweather-sans-v26-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'merriweather-sans-v26-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'merriweather-sans-v26-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'merriweather-sans-v26-latin-800italic', local: [] },
    ],
  },
  {
    fontFamily: 'Merriweather',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'merriweather-v30-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'merriweather-v30-latin-regular', local: [] },
      { style: 'normal', weight: '700', file: 'merriweather-v30-latin-700', local: [] },
      { style: 'normal', weight: '900', file: 'merriweather-v30-latin-900', local: [] },
      { style: 'italic', weight: '300', file: 'merriweather-v30-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'merriweather-v30-latin-italic', local: [] },
      { style: 'italic', weight: '700', file: 'merriweather-v30-latin-700italic', local: [] },
      { style: 'italic', weight: '900', file: 'merriweather-v30-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Monoton',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'monoton-v20-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Montserrat',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'montserrat-v29-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'montserrat-v29-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'montserrat-v29-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'montserrat-v29-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'montserrat-v29-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'montserrat-v29-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'montserrat-v29-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'montserrat-v29-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'montserrat-v29-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'montserrat-v29-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'montserrat-v29-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'montserrat-v29-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'montserrat-v29-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'montserrat-v29-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'montserrat-v29-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'montserrat-v29-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'montserrat-v29-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'montserrat-v29-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Noto Sans',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'noto-sans-v38-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'noto-sans-v38-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'noto-sans-v38-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'noto-sans-v38-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'noto-sans-v38-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'noto-sans-v38-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'noto-sans-v38-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'noto-sans-v38-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'noto-sans-v38-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'noto-sans-v38-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'noto-sans-v38-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'noto-sans-v38-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'noto-sans-v38-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'noto-sans-v38-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'noto-sans-v38-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'noto-sans-v38-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'noto-sans-v38-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'noto-sans-v38-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Noto Serif',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'noto-serif-v23-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'noto-serif-v23-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'noto-serif-v23-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'noto-serif-v23-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'noto-serif-v23-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'noto-serif-v23-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'noto-serif-v23-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'noto-serif-v23-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'noto-serif-v23-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'noto-serif-v23-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'noto-serif-v23-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'noto-serif-v23-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'noto-serif-v23-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'noto-serif-v23-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'noto-serif-v23-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'noto-serif-v23-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'noto-serif-v23-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'noto-serif-v23-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Nunito Sans',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'nunito-sans-v15-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'nunito-sans-v15-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'nunito-sans-v15-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'nunito-sans-v15-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'nunito-sans-v15-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'nunito-sans-v15-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'nunito-sans-v15-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'nunito-sans-v15-latin-900', local: [] },
      { style: 'italic', weight: '200', file: 'nunito-sans-v15-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'nunito-sans-v15-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'nunito-sans-v15-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'nunito-sans-v15-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'nunito-sans-v15-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'nunito-sans-v15-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'nunito-sans-v15-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'nunito-sans-v15-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Nunito',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'nunito-v26-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'nunito-v26-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'nunito-v26-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'nunito-v26-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'nunito-v26-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'nunito-v26-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'nunito-v26-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'nunito-v26-latin-900', local: [] },
      { style: 'italic', weight: '200', file: 'nunito-v26-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'nunito-v26-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'nunito-v26-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'nunito-v26-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'nunito-v26-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'nunito-v26-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'nunito-v26-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'nunito-v26-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Open Sans',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'open-sans-v40-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'open-sans-v40-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'open-sans-v40-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'open-sans-v40-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'open-sans-v40-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'open-sans-v40-latin-800', local: [] },
      { style: 'italic', weight: '300', file: 'open-sans-v40-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'open-sans-v40-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'open-sans-v40-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'open-sans-v40-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'open-sans-v40-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'open-sans-v40-latin-800italic', local: [] },
    ],
  },
  {
    fontFamily: 'Orbitron',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'orbitron-v31-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'orbitron-v31-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'orbitron-v31-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'orbitron-v31-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'orbitron-v31-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'orbitron-v31-latin-900', local: [] },
    ],
  },
  {
    fontFamily: 'Oswald',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'oswald-v53-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'oswald-v53-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'oswald-v53-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'oswald-v53-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'oswald-v53-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'oswald-v53-latin-700', local: [] },
    ],
  },
  {
    fontFamily: 'Outfit',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'outfit-v11-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'outfit-v11-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'outfit-v11-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'outfit-v11-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'outfit-v11-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'outfit-v11-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'outfit-v11-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'outfit-v11-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'outfit-v11-latin-900', local: [] },
    ],
  },
  {
    fontFamily: 'Overpass',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'overpass-v16-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'overpass-v16-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'overpass-v16-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'overpass-v16-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'overpass-v16-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'overpass-v16-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'overpass-v16-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'overpass-v16-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'overpass-v16-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'overpass-v16-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'overpass-v16-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'overpass-v16-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'overpass-v16-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'overpass-v16-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'overpass-v16-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'overpass-v16-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'overpass-v16-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'overpass-v16-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Pacifico',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'pacifico-v22-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Palanquin',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'palanquin-v16-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'palanquin-v16-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'palanquin-v16-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'palanquin-v16-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'palanquin-v16-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'palanquin-v16-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'palanquin-v16-latin-700', local: [] },
    ],
  },
  {
    fontFamily: 'Poppins',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'poppins-v22-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'poppins-v22-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'poppins-v22-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'poppins-v22-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'poppins-v22-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'poppins-v22-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'poppins-v22-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'poppins-v22-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'poppins-v22-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'poppins-v22-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'poppins-v22-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'poppins-v22-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'poppins-v22-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'poppins-v22-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'poppins-v22-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'poppins-v22-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'poppins-v22-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'poppins-v22-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Press Start 2P',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'press-start-2p-v15-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Quattrocento Sans',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'quattrocento-sans-v21-latin-regular', local: [] },
      { style: 'normal', weight: '700', file: 'quattrocento-sans-v21-latin-700', local: [] },
      { style: 'italic', weight: '400', file: 'quattrocento-sans-v21-latin-italic', local: [] },
      { style: 'italic', weight: '700', file: 'quattrocento-sans-v21-latin-700italic', local: [] },
    ],
  },
  {
    fontFamily: 'Quicksand',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'quicksand-v31-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'quicksand-v31-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'quicksand-v31-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'quicksand-v31-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'quicksand-v31-latin-700', local: [] },
    ],
  },
  {
    fontFamily: 'Raleway',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'raleway-v34-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'raleway-v34-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'raleway-v34-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'raleway-v34-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'raleway-v34-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'raleway-v34-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'raleway-v34-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'raleway-v34-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'raleway-v34-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'raleway-v34-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'raleway-v34-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'raleway-v34-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'raleway-v34-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'raleway-v34-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'raleway-v34-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'raleway-v34-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'raleway-v34-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'raleway-v34-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Roboto',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'roboto-v47-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'roboto-v47-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'roboto-v47-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'roboto-v47-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'roboto-v47-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'roboto-v47-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'roboto-v47-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'roboto-v47-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'roboto-v47-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'roboto-v47-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'roboto-v47-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'roboto-v47-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'roboto-v47-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'roboto-v47-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'roboto-v47-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'roboto-v47-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'roboto-v47-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'roboto-v47-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Roboto Slab',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'roboto-slab-v34-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'roboto-slab-v34-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'roboto-slab-v34-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'roboto-slab-v34-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'roboto-slab-v34-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'roboto-slab-v34-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'roboto-slab-v34-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'roboto-slab-v34-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'roboto-slab-v34-latin-900', local: [] },
    ],
  },
  {
    fontFamily: 'Rubik',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'rubik-v28-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'rubik-v28-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'rubik-v28-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'rubik-v28-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'rubik-v28-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'rubik-v28-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'rubik-v28-latin-900', local: [] },
      { style: 'italic', weight: '300', file: 'rubik-v28-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'rubik-v28-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'rubik-v28-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'rubik-v28-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'rubik-v28-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'rubik-v28-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'rubik-v28-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Sacramento',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'sacramento-v15-latin-regular', local: [] }],
  },
  {
    fontFamily: 'Sanchez',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'sanchez-v15-latin-regular', local: [] },
      { style: 'italic', weight: '400', file: 'sanchez-v15-latin-italic', local: [] },
    ],
  },
  {
    fontFamily: 'Sour Gummy',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'sour-gummy-v1-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'sour-gummy-v1-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'sour-gummy-v1-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'sour-gummy-v1-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'sour-gummy-v1-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'sour-gummy-v1-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'sour-gummy-v1-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'sour-gummy-v1-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'sour-gummy-v1-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'sour-gummy-v1-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'sour-gummy-v1-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'sour-gummy-v1-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'sour-gummy-v1-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'sour-gummy-v1-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'sour-gummy-v1-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'sour-gummy-v1-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'sour-gummy-v1-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'sour-gummy-v1-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Source Sans Pro',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'source-sans-3-v15-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'source-sans-3-v15-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'source-sans-3-v15-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'source-sans-3-v15-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'source-sans-3-v15-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'source-sans-3-v15-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'source-sans-3-v15-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'source-sans-3-v15-latin-900', local: [] },
      { style: 'italic', weight: '200', file: 'source-sans-3-v15-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'source-sans-3-v15-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'source-sans-3-v15-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'source-sans-3-v15-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'source-sans-3-v15-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'source-sans-3-v15-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'source-sans-3-v15-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'source-sans-3-v15-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Source Serif Pro',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'source-serif-4-v8-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'source-serif-4-v8-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'source-serif-4-v8-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'source-serif-4-v8-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'source-serif-4-v8-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'source-serif-4-v8-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'source-serif-4-v8-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'source-serif-4-v8-latin-900', local: [] },
      { style: 'italic', weight: '200', file: 'source-serif-4-v8-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'source-serif-4-v8-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'source-serif-4-v8-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'source-serif-4-v8-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'source-serif-4-v8-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'source-serif-4-v8-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'source-serif-4-v8-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'source-serif-4-v8-latin-900italic', local: [] },
    ],
  },
  {
    fontFamily: 'Space Grotesk',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'space-grotesk-v16-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'space-grotesk-v16-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'space-grotesk-v16-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'space-grotesk-v16-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'space-grotesk-v16-latin-700', local: [] },
    ],
  },
  {
    fontFamily: 'Space Mono',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'space-mono-v14-latin-regular', local: [] },
      { style: 'normal', weight: '700', file: 'space-mono-v14-latin-700', local: [] },
      { style: 'italic', weight: '400', file: 'space-mono-v14-latin-italic', local: [] },
      { style: 'italic', weight: '700', file: 'space-mono-v14-latin-700italic', local: [] },
    ],
  },
  {
    fontFamily: 'Ubuntu',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'ubuntu-v20-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'ubuntu-v20-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'ubuntu-v20-latin-500', local: [] },
      { style: 'normal', weight: '700', file: 'ubuntu-v20-latin-700', local: [] },
      { style: 'italic', weight: '300', file: 'ubuntu-v20-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'ubuntu-v20-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'ubuntu-v20-latin-500italic', local: [] },
      { style: 'italic', weight: '700', file: 'ubuntu-v20-latin-700italic', local: [] },
    ],
  },
  {
    fontFamily: 'Work Sans',
    fontPath: '/assets/fonts/google/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'work-sans-v19-latin-100', local: [] },
      { style: 'normal', weight: '200', file: 'work-sans-v19-latin-200', local: [] },
      { style: 'normal', weight: '300', file: 'work-sans-v19-latin-300', local: [] },
      { style: 'normal', weight: '400', file: 'work-sans-v19-latin-regular', local: [] },
      { style: 'normal', weight: '500', file: 'work-sans-v19-latin-500', local: [] },
      { style: 'normal', weight: '600', file: 'work-sans-v19-latin-600', local: [] },
      { style: 'normal', weight: '700', file: 'work-sans-v19-latin-700', local: [] },
      { style: 'normal', weight: '800', file: 'work-sans-v19-latin-800', local: [] },
      { style: 'normal', weight: '900', file: 'work-sans-v19-latin-900', local: [] },
      { style: 'italic', weight: '100', file: 'work-sans-v19-latin-100italic', local: [] },
      { style: 'italic', weight: '200', file: 'work-sans-v19-latin-200italic', local: [] },
      { style: 'italic', weight: '300', file: 'work-sans-v19-latin-300italic', local: [] },
      { style: 'italic', weight: '400', file: 'work-sans-v19-latin-italic', local: [] },
      { style: 'italic', weight: '500', file: 'work-sans-v19-latin-500italic', local: [] },
      { style: 'italic', weight: '600', file: 'work-sans-v19-latin-600italic', local: [] },
      { style: 'italic', weight: '700', file: 'work-sans-v19-latin-700italic', local: [] },
      { style: 'italic', weight: '800', file: 'work-sans-v19-latin-800italic', local: [] },
      { style: 'italic', weight: '900', file: 'work-sans-v19-latin-900italic', local: [] },
    ],
  },
  // 23degrees
  {
    fontFamily: 'Nimbus Sans L',
    fontPath: '/assets/fonts/nimbus-sans-l/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'NimbusSanL-Regu', local: [] },
      { style: 'italic', weight: '400', file: 'NimbusSanL-ReguItal', local: [] },
      { style: 'normal', weight: '700', file: 'NimbusSanL-Bold', local: [] },
      { style: 'italic', weight: '700', file: 'NimbusSanL-BoldItal', local: [] },
    ],
  },
  {
    fontFamily: 'Nimbus Sans L Cond',
    fontPath: '/assets/fonts/nimbus-sans-l/',
    fontTypes: ['ttf'],
    fontFaces: [
      // format bug
      { style: 'normal', weight: '400', file: 'NimbusSanL-ReguCond', local: [] },
      { style: 'italic', weight: '400', file: 'NimbusSanL-ReguCondItal', local: [] },
      { style: 'normal', weight: '700', file: 'NimbusSanL-BoldCond', local: [] },
      { style: 'italic', weight: '700', file: 'NimbusSanL-BoldCondItal', local: [] },
    ],
  },
  // Tagesschau
  {
    fontFamily: 'The Sans',
    fontPath: '/assets/fonts/tagesschau/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'TheSans-2ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'TheSans-3Light', local: [] },
      { style: 'normal', weight: '400', file: 'TheSans-4SemiLight', local: [] },
      { style: 'normal', weight: '500', file: 'TheSans-5Regular', local: [] },
      { style: 'normal', weight: '600', file: 'TheSans-6SemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'TheSans-7Bold', local: [] },
      { style: 'normal', weight: '800', file: 'TheSans-8ExtraBold', local: [] },
      { style: 'normal', weight: '900', file: 'TheSans-9Black', local: [] },
    ],
  },
  {
    fontFamily: 'The Sans Expert',
    fontPath: '/assets/fonts/tagesschau/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'TheSans-2ExtraLightExpert', local: [] },
      { style: 'normal', weight: '300', file: 'TheSans-3LightExpert', local: [] },
      { style: 'normal', weight: '400', file: 'TheSans-4SemiLightExpert', local: [] },
      { style: 'normal', weight: '500', file: 'TheSans-5RegularExpert', local: [] },
      { style: 'normal', weight: '600', file: 'TheSans-6SemiBoldExpert', local: [] },
      { style: 'normal', weight: '700', file: 'TheSans-7BoldExpert', local: [] },
      { style: 'normal', weight: '800', file: 'TheSans-8ExtraBoldExpert', local: [] },
      { style: 'normal', weight: '900', file: 'TheSans-9BlackExpert', local: [] },
    ],
  },
  {
    fontFamily: 'The Sans B',
    fontPath: '/assets/fonts/tagesschau/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'TheSans-B3Light', local: [] },
      { style: 'normal', weight: '400', file: 'TheSans-B4SemiLight', local: [] },
      { style: 'normal', weight: '500', file: 'TheSans-B5Regular', local: [] },
      { style: 'normal', weight: '600', file: 'TheSans-B6SemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'TheSans-B7Bold', local: [] },
      { style: 'normal', weight: '800', file: 'TheSans-B8ExtraBold', local: [] },
      { style: 'normal', weight: '900', file: 'TheSans-B9Black', local: [] },
    ],
  },
  {
    fontFamily: 'The Sans C',
    fontPath: '/assets/fonts/tagesschau/',
    fontTypes: ['woff2', 'woff'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'TheSansC5-2_ExtraLight', local: [] },
      { style: 'italic', weight: '200', file: 'TheSansC5-2iExtraLightIta', local: [] },
      { style: 'normal', weight: '300', file: 'TheSansC5-3_Light', local: [] },
      { style: 'italic', weight: '300', file: 'TheSansC5-3iLightItalic', local: [] },
      { style: 'normal', weight: '400', file: 'TheSansC5-4_SemiLight', local: [] },
      { style: 'italic', weight: '400', file: 'TheSansC5-4iSemiLightIta', local: [] },
      { style: 'normal', weight: '500', file: 'TheSansC5-5_Plain', local: [] },
      { style: 'italic', weight: '500', file: 'TheSansC5-5iPlainItalic', local: [] },
      { style: 'normal', weight: '600', file: 'TheSansC5-6_SemiBold', local: [] },
      { style: 'italic', weight: '600', file: 'TheSansC5-6iSemiBoldIta', local: [] },
      { style: 'normal', weight: '700', file: 'TheSansC5-7_Bold', local: [] },
      { style: 'italic', weight: '700', file: 'TheSansC5-7iBoldItalic', local: [] },
      { style: 'normal', weight: '800', file: 'TheSansC5-8_ExtraBold', local: [] },
      { style: 'italic', weight: '800', file: 'TheSansC5-8iExtraBoldIta', local: [] },
      { style: 'normal', weight: '900', file: 'TheSansC5-9_Black', local: [] },
      { style: 'italic', weight: '900', file: 'TheSansC5-9iBlackItalic', local: [] },
    ],
  },
  {
    fontFamily: 'The Sans C5s',
    fontPath: '/assets/fonts/tagesschau/',
    fontTypes: ['woff2', 'woff'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'TheSansC5s-2_ExtraLight', local: [] },
      { style: 'italic', weight: '200', file: 'TheSansC5s-2_ExtraLightItalic', local: [] },
      { style: 'normal', weight: '300', file: 'TheSansC5s-3_Light', local: [] },
      { style: 'italic', weight: '300', file: 'TheSansC5s-3_LightItalic', local: [] },
      { style: 'normal', weight: '400', file: 'TheSansC5s-4_SemiLight', local: [] },
      { style: 'italic', weight: '400', file: 'TheSansC5s-4_SemiLightItalic', local: [] },
      { style: 'normal', weight: '500', file: 'TheSansC5s-5_Plain', local: [] },
      { style: 'italic', weight: '500', file: 'TheSansC5s-5_PlainItalic', local: [] },
      { style: 'normal', weight: '600', file: 'TheSansC5s-6_SemiBold', local: [] },
      { style: 'italic', weight: '600', file: 'TheSansC5s-6_SemiBoldItalic', local: [] },
      { style: 'normal', weight: '700', file: 'TheSansC5s-7_Bold', local: [] },
      { style: 'italic', weight: '700', file: 'TheSansC5s-7_BoldItalic', local: [] },
      { style: 'normal', weight: '800', file: 'TheSansC5s-8_ExtraBold', local: [] },
      { style: 'italic', weight: '800', file: 'TheSansC5s-8_ExtraBoldItalic', local: [] },
      { style: 'normal', weight: '900', file: 'TheSansC5s-9_Black', local: [] },
      { style: 'italic', weight: '900', file: 'TheSansC5s-9_BlackItalic', local: [] },
    ],
  },
  // LBS
  {
    fontFamily: 'Thesis',
    fontPath: '/assets/fonts/lbs/',
    fontTypes: ['ttf'],
    fontFaces: [
      // format bug
      { style: 'normal', weight: '400', file: 'LBSThesis-Plain', local: [] },
      { style: 'normal', weight: '800', file: 'LBSThesis-ExtraBold', local: [] },
    ],
  },
  // GDV
  {
    fontFamily: 'GDV',
    fontPath: '/assets/fonts/gdv/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'GDVtype-Hairline', local: [] },
      { style: 'normal', weight: '200', file: 'GDVtype-Thin', local: [] },
      { style: 'normal', weight: '300', file: 'GDVtype-ExtraLight', local: [] },
      { style: 'normal', weight: '400', file: 'GDVtype-Light', local: [] },
      { style: 'normal', weight: '500', file: 'GDVtype-Regular', local: [] },
      { style: 'normal', weight: '600', file: 'GDVtype-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'GDVtype-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'GDVtype-Black', local: [] },
      { style: 'normal', weight: '900', file: 'GDVtype-Ultra', local: [] },
    ],
  },
  {
    fontFamily: 'Söhne',
    fontPath: '/assets/fonts/gdv/',
    fontTypes: ['woff2'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'soehne-extraleicht', local: [] },
      { style: 'italic', weight: '200', file: 'soehne-extraleicht-kursiv', local: [] },
      { style: 'normal', weight: '300', file: 'soehne-leicht', local: [] },
      { style: 'italic', weight: '300', file: 'soehne-leicht-kursiv', local: [] },
      { style: 'normal', weight: '400', file: 'soehne-buch', local: [] },
      { style: 'italic', weight: '400', file: 'soehne-buch-kursiv', local: [] },
      { style: 'normal', weight: '500', file: 'soehne-kraftig', local: [] },
      { style: 'italic', weight: '500', file: 'soehne-kraftig-kursiv', local: [] },
      { style: 'normal', weight: '600', file: 'soehne-dreiviertelfett', local: [] },
      { style: 'italic', weight: '600', file: 'soehne-dreiviertelfett-kursiv', local: [] },
      { style: 'normal', weight: '700', file: 'soehne-fett', local: [] },
      { style: 'italic', weight: '700', file: 'soehne-fett-kursiv', local: [] },
      { style: 'normal', weight: '800', file: 'soehne-extrafett', local: [] },
      { style: 'italic', weight: '800', file: 'soehne-extrafett-kursiv', local: [] },
    ],
  },
  {
    fontFamily: 'Söhne Mono',
    fontPath: '/assets/fonts/gdv/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'soehne-mono-extraleicht', local: [] },
      { style: 'italic', weight: '200', file: 'soehne-mono-extraleichtkursiv', local: [] },
      { style: 'normal', weight: '300', file: 'soehne-mono-leicht', local: [] },
      { style: 'italic', weight: '300', file: 'soehne-mono-leichtkursiv', local: [] },
      { style: 'normal', weight: '400', file: 'soehne-mono-buch', local: [] },
      { style: 'italic', weight: '400', file: 'soehne-mono-buchkursiv', local: [] },
      { style: 'normal', weight: '500', file: 'soehne-mono-halbfett', local: [] },
      { style: 'italic', weight: '500', file: 'soehne-mono-halbfettkursiv', local: [] },
      { style: 'normal', weight: '600', file: 'soehne-mono-dreiviertelfett', local: [] },
      { style: 'italic', weight: '600', file: 'soehne-mono-dreiviertelfettkursiv', local: [] },
      { style: 'normal', weight: '700', file: 'soehne-mono-fett', local: [] },
      { style: 'italic', weight: '700', file: 'soehne-mono-fettkursiv', local: [] },
      { style: 'normal', weight: '800', file: 'soehne-mono-extrafett', local: [] },
      { style: 'italic', weight: '800', file: 'soehne-mono-extrafettkursiv', local: [] },
    ],
  },
  {
    fontFamily: 'Tiempos Text',
    fontPath: '/assets/fonts/gdv/',
    fontTypes: ['woff2'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'tiempos-text-regular', local: [] },
      { style: 'italic', weight: '400', file: 'tiempos-text-regular-italic', local: [] },
      { style: 'normal', weight: '500', file: 'tiempos-text-medium', local: [] },
      { style: 'italic', weight: '500', file: 'tiempos-text-medium-italic', local: [] },
      { style: 'normal', weight: '600', file: 'tiempos-text-semibold', local: [] },
      { style: 'italic', weight: '600', file: 'tiempos-text-semibold-italic', local: [] },
      { style: 'normal', weight: '700', file: 'tiempos-text-bold', local: [] },
      { style: 'italic', weight: '700', file: 'tiempos-text-bold-italic', local: [] },
    ],
  },
  {
    fontFamily: 'GDV Tabellen',
    fontPath: '/assets/fonts/gdv/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'GDV_Tabellen-Light', local: [] },
      { style: 'normal', weight: '400', file: 'GDV_Tabellen-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'GDV_Tabellen-Medium', local: [] },
    ],
  },
  // MBR
  {
    fontFamily: 'National 2',
    fontPath: '/assets/fonts/mbr/',
    fontTypes: ['woff'],
    fontFaces: [
      // format bug
      { style: 'normal', weight: '400', file: 'National2Web-Regular', local: [] },
      { style: 'normal', weight: '700', file: 'National2Web-Bold', local: [] },
    ],
  },
  // Kurier
  {
    fontFamily: 'Antenna Cond',
    fontPath: '/assets/fonts/kurier/antenna-cond/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'AntennaCond-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'AntennaCond-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'AntennaCond-Light', local: [] },
      { style: 'normal', weight: '400', file: 'AntennaCond-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'AntennaCond-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'AntennaCond-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'AntennaCond-Black', local: [] },
    ],
  },
  {
    fontFamily: 'Charter ITC Pro',
    fontPath: '/assets/fonts/kurier/charter-itc-pro/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'CharterITCPro-Regular', local: [] },
      { style: 'normal', weight: '700', file: 'CharterITCPro-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'CharterITCPro-Black', local: [] },
    ],
  },
  {
    fontFamily: 'Meta Headline Cond OT',
    fontPath: '/assets/fonts/kurier/meta-headline-ot/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'MetaHeadlineCondOT-Light', local: [] },
      { style: 'normal', weight: '400', file: 'MetaHeadlineCondOT-Regular', local: [] },
      { style: 'normal', weight: '700', file: 'MetaHeadlineCondOT-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'MetaHeadlineCondOT-Black', local: [] },
    ],
  },
  {
    fontFamily: 'Meta Headline Cond OTNg',
    fontPath: '/assets/fonts/kurier/meta-headline-otng/',
    fontTypes: ['otf'],
    fontFaces: [
      // format bug
      { style: 'normal', weight: '400', file: 'METAHCOR', local: [] },
      { style: 'normal', weight: '700', file: 'METAHCOB', local: [] },
    ],
  },
  // Agenda Austria
  {
    fontFamily: 'Museo Sans AA',
    fontPath: '/assets/fonts/agenda-austria/',
    fontTypes: ['otf'],
    fontFaces: [
      // format bug
      { style: 'normal', weight: '700', file: 'MuseoSans_700', local: [] },
      { style: 'normal', weight: '900', file: 'MuseoSans_900', local: [] },
    ],
  },
  // willhaben
  {
    fontFamily: 'The Sans willhaben',
    fontPath: '/assets/fonts/willhaben/thesans/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'ExtraLight', local: [] },
      { style: 'italic', weight: '200', file: 'ExtraLightItalic', local: [] },
      { style: 'normal', weight: '300', file: 'Light', local: [] },
      { style: 'italic', weight: '300', file: 'LightItalic', local: [] },
      { style: 'normal', weight: '400', file: 'SemiLight', local: [] },
      { style: 'italic', weight: '400', file: 'SemiLightItalic', local: [] },
      { style: 'normal', weight: '500', file: 'Plain', local: [] },
      { style: 'italic', weight: '500', file: 'PlainItalic', local: [] },
      { style: 'normal', weight: '600', file: 'SemiBold', local: [] },
      { style: 'italic', weight: '600', file: 'SemiBoldItalic', local: [] },
      { style: 'normal', weight: '700', file: 'Bold', local: [] },
      { style: 'italic', weight: '700', file: 'BoldItalic', local: [] },
      { style: 'normal', weight: '800', file: 'ExtraBold', local: [] },
      { style: 'italic', weight: '800', file: 'ExtraBoldItalic', local: [] },
      { style: 'normal', weight: '900', file: 'Black', local: [] },
      { style: 'italic', weight: '900', file: 'BlackItalic', local: [] },
    ],
  },
  // Die Presse
  {
    fontFamily: 'Benton Sans Comp',
    fontPath: '/assets/fonts/presse/',
    fontTypes: ['otf'],
    fontFaces: [
      // format bug
      { style: 'normal', weight: '400', file: 'BentonSansComp-Book', local: [] },
      { style: 'normal', weight: '500', file: 'BentonSansComp-Medium', local: [] },
    ],
  },
  {
    fontFamily: 'Benton Sans Cond',
    fontPath: '/assets/fonts/presse/',
    fontTypes: ['otf'],
    fontFaces: [
      // format bug
      { style: 'normal', weight: '400', file: 'BentonSansCond-Book', local: [] },
      { style: 'normal', weight: '700', file: 'BentonSansCond-Bold', local: [] },
    ],
  },
  // moment.at
  {
    fontFamily: 'Firs',
    fontPath: '/assets/fonts/moment/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'TTFirs-Hairline', local: [] },
      { style: 'italic', weight: '100', file: 'TTFirs-HairlineItalic', local: [] },
      { style: 'normal', weight: '200', file: 'TTFirs-Thin', local: [] },
      { style: 'italic', weight: '200', file: 'TTFirs-ThinItalic', local: [] },
      { style: 'normal', weight: '300', file: 'TTFirs-ExtraLight', local: [] },
      { style: 'italic', weight: '300', file: 'TTFirs-ExtraLightItalic', local: [] },
      { style: 'normal', weight: '400', file: 'TTFirs-Light', local: [] },
      { style: 'italic', weight: '400', file: 'TTFirs-LightItalic', local: [] },
      { style: 'normal', weight: '500', file: 'TTFirs-Regular', local: [] },
      { style: 'italic', weight: '500', file: 'TTFirs-Italic', local: [] },
      { style: 'normal', weight: '600', file: 'TTFirs-Medium', local: [] },
      { style: 'italic', weight: '600', file: 'TTFirs-MediumItalic', local: [] },
      { style: 'normal', weight: '700', file: 'TTFirs-Bold', local: [] },
      { style: 'italic', weight: '700', file: 'TTFirs-BoldItalic', local: [] },
      { style: 'normal', weight: '800', file: 'TTFirs-ExtraBold', local: [] },
      { style: 'italic', weight: '800', file: 'TTFirs-ExtraBoldItalic', local: [] },
      { style: 'normal', weight: '900', file: 'TTFirs-Black', local: [] },
      { style: 'italic', weight: '900', file: 'TTFirs-BlackItalic', local: [] },
    ],
  },
  // nord bayern
  {
    fontFamily: 'Milo Serif Pro',
    fontPath: '/assets/fonts/nord-bayern/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'MiloSerifPro', local: [] },
      { style: 'italic', weight: '400', file: 'MiloSerifPro-Italic', local: [] },
      { style: 'normal', weight: '500', file: 'MiloSerifPro-Text', local: [] },
      { style: 'italic', weight: '500', file: 'MiloSerifPro-TextItalic', local: [] },
      { style: 'normal', weight: '600', file: 'MiloSerifPro-Medium', local: [] },
      { style: 'italic', weight: '600', file: 'MiloSerifPro-MediumItalic', local: [] },
      { style: 'normal', weight: '700', file: 'MiloSerifPro-Bold', local: [] },
      { style: 'italic', weight: '700', file: 'MiloSerifPro-BoldItalic', local: [] },
      { style: 'normal', weight: '800', file: 'MiloSerifPro-Extrabold', local: [] },
      { style: 'italic', weight: '800', file: 'MiloSerifPro-ExtraboldIta', local: [] },
      { style: 'normal', weight: '900', file: 'MiloSerifPro-Black', local: [] },
      { style: 'italic', weight: '900', file: 'MiloSerifPro-BlackItalic', local: [] },
    ],
  },
  {
    fontFamily: 'Verb',
    fontPath: '/assets/fonts/nord-bayern/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'VerbLight', local: [] },
      { style: 'italic', weight: '300', file: 'VerbLight-Italic', local: [] },
      { style: 'normal', weight: '400', file: 'VerbRegular', local: [] },
      { style: 'italic', weight: '400', file: 'VerbRegular-Italic', local: [] },
      { style: 'normal', weight: '500', file: 'VerbMedium', local: [] },
      { style: 'italic', weight: '500', file: 'VerbMedium-Italic', local: [] },
      { style: 'normal', weight: '700', file: 'VerbRegular-Bold', local: [] },
      { style: 'italic', weight: '700', file: 'VerbRegular-BoldItalic', local: [] },
      // { style: 'italic', weight: '900', file: 'VerbBlack-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'Verb Comp',
    fontPath: '/assets/fonts/nord-bayern/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'VerbCompLight', local: [] },
      { style: 'italic', weight: '300', file: 'VerbCompLight-Italic', local: [] },
      { style: 'normal', weight: '400', file: 'VerbCompRegular', local: [] },
      { style: 'italic', weight: '400', file: 'VerbCompRegular-Italic', local: [] },
      { style: 'normal', weight: '500', file: 'VerbCompMedium', local: [] },
      { style: 'italic', weight: '500', file: 'VerbCompMedium-Italic', local: [] },
      { style: 'normal', weight: '600', file: 'VerbCompSemibold', local: [] },
      { style: 'italic', weight: '600', file: 'VerbCompSemibold-Italic', local: [] },
      { style: 'normal', weight: '700', file: 'VerbCompRegular-Bold', local: [] },
      { style: 'italic', weight: '700', file: 'VerbCompRegular-BoldItalic', local: [] },
      { style: 'normal', weight: '800', file: 'VerbCompExtrabold', local: [] },
      { style: 'italic', weight: '800', file: 'VerbCompExtrabold-Italic', local: [] },
      { style: 'normal', weight: '900', file: 'VerbCompBlack', local: [] },
      { style: 'italic', weight: '900', file: 'VerbCompBlack-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'Verb Cond',
    fontPath: '/assets/fonts/nord-bayern/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'VerbExCondRegular', local: [] },
      { style: 'italic', weight: '400', file: 'VerbExCondRegular-Italic', local: [] },
      { style: 'normal', weight: '600', file: 'VerbCondSemibold', local: [] },
      { style: 'italic', weight: '600', file: 'VerbCondSemibold-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'Helvetica Standard',
    fontPath: '/assets/fonts/nord-bayern/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'Helvetica-Standard', local: [] },
      { style: 'italic', weight: '400', file: 'Helvetica-Standard-Kursiv', local: [] },
      { style: 'normal', weight: '600', file: 'Helvetica-Standard-Halbfett', local: [] },
      { style: 'normal', weight: '700', file: 'Helvetica-Standard-Fett', local: [] },
    ],
  },
  {
    fontFamily: 'Frutiger',
    fontPath: '/assets/fonts/nord-bayern/',
    fontTypes: ['ttf'],
    fontFaces: [
      // format bug
      { style: 'normal', weight: '400', file: 'Frutiger-Regular', local: [] },
      { style: 'normal', weight: '700', file: 'Frutiger-Bold', local: [] },
    ],
  },
  // vcö
  {
    fontFamily: 'Helvetica VCÖ',
    fontPath: '/assets/fonts/vcoe/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'HelveticaLT47LightCondensed', local: [] },
      { style: 'italic', weight: '300', file: 'HelveticaLT47LightCondensedOblique', local: [] },
      { style: 'normal', weight: '600', file: 'HelveticaLT67MediumCondensed', local: [] },
      { style: 'italic', weight: '600', file: 'HelveticaLT67MediumCondensedOblique', local: [] },
      { style: 'normal', weight: '800', file: 'HelveticaLT87HeavyCondensed', local: [] },
    ],
  },
  // Schwäbische
  {
    fontFamily: 'Poynter Gothic Text',
    fontPath: '/assets/fonts/schwaebische/',
    fontTypes: ['otf'],
    fontFaces: [{ style: 'normal', weight: '900', file: 'PoynterGothicText-Black', local: [] }],
  },
  {
    fontFamily: 'Poynter Gothic Cond',
    fontPath: '/assets/fonts/schwaebische/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'PoynterGothicTextCond-Light', local: [] },
      { style: 'normal', weight: '400', file: 'PoynterGothicTextCond-Reg', local: [] },
      { style: 'normal', weight: '700', file: 'PoynterGothicTextCond-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'PoynterGothicTextCond-Black', local: [] },
    ],
  },
  {
    fontFamily: 'Poynter OS Display',
    fontPath: '/assets/fonts/schwaebische/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'PoynterOSDisplay-Roman', local: [] },
      { style: 'italic', weight: '400', file: 'PoynterOSDisplay-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'Poynter OS Text',
    fontPath: '/assets/fonts/schwaebische/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'PoynterOSTextOne-Roman', local: [] },
      { style: 'normal', weight: '700', file: 'PoynterOSTextThree-Roman', local: [] },
    ],
  },
  {
    fontFamily: 'Poynter OS Text L',
    fontPath: '/assets/fonts/schwaebische/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'PoynterOSTextOneL-Roman', local: [] },
      { style: 'normal', weight: '700', file: 'PoynterOSTextThreeL-Roman', local: [] },
    ],
  },
  {
    fontFamily: 'Walburn',
    fontPath: '/assets/fonts/schwaebische/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'Walburn-Regular', local: [] },
      { style: 'italic', weight: '400', file: 'Walburn-Italic', local: [] },
      { style: 'normal', weight: '700', file: 'Walburn-Bold', local: [] },
    ],
  },
  // KleineZeitung
  {
    fontFamily: 'KleineSans',
    fontPath: '/assets/fonts/kleinezeitung/KleineSans/',
    fontTypes: ['otf', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'KleineSans-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'KleineSans-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'KleineSans-Light', local: [] },
      { style: 'normal', weight: '400', file: 'KleineSans-Normal', local: [] },
      { style: 'normal', weight: '500', file: 'KleineSans-Regular', local: [] },
      { style: 'normal', weight: '600', file: 'KleineSans-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'KleineSans-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'KleineSans-Ultra', local: [] },
      // { style: 'normal', weight: 'xxx', file: 'KleineSans-Middle', local: [] }, // ???
    ],
  },
  {
    fontFamily: 'KleineSans Cond',
    fontPath: '/assets/fonts/kleinezeitung/KleineSans/',
    fontTypes: ['otf', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'KleineSansCondensed-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'KleineSansCondensed-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'KleineSansCondensed-Light', local: [] },
      { style: 'normal', weight: '400', file: 'KleineSansCondensed-Normal', local: [] },
      { style: 'normal', weight: '500', file: 'KleineSansCondensed-Regular', local: [] },
      { style: 'normal', weight: '600', file: 'KleineSansCondensed-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'KleineSansCondensed-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'KleineSansCondensed-Ultra', local: [] },
    ],
  },
  {
    fontFamily: 'KleineTitel',
    fontPath: '/assets/fonts/kleinezeitung/KleineTitel/',
    fontTypes: ['otf', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'KleineTitel-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'KleineTitel-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'KleineTitel-Light', local: [] },
      // { style: 'normal', weight: '400', file: 'KleineTitel-Normal', local: [] },
      { style: 'normal', weight: '500', file: 'KleineTitel-Regular', local: [] },
      { style: 'normal', weight: '600', file: 'KleineTitel-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'KleineTitel-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'KleineTitel-Ultra', local: [] },
    ],
  },
  {
    fontFamily: 'KleineTitel Cond',
    fontPath: '/assets/fonts/kleinezeitung/KleineTitel/',
    fontTypes: ['otf', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'KleineTitelCondensed-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'KleineTitelCondensed-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'KleineTitelCondensed-Light', local: [] },
      // { style: 'normal', weight: '400', file: 'KleineTitelCondensed-Normal', local: [] },
      { style: 'normal', weight: '500', file: 'KleineTitelCondensed-Regular', local: [] },
      { style: 'normal', weight: '600', file: 'KleineTitelCondensed-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'KleineTitelCondensed-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'KleineTitelCondensed-Ultra', local: [] },
    ],
  },
  // Germanwatch
  {
    fontFamily: 'Inter GW',
    fontPath: '/assets/fonts/germanwatch/',
    fontTypes: ['woff2', 'woff'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'Inter-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'Inter-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'Inter-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Inter-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'Inter-Medium', local: [] },
      { style: 'normal', weight: '600', file: 'Inter-SemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'Inter-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'Inter-ExtraBold', local: [] },
      { style: 'normal', weight: '900', file: 'Inter-Black', local: [] },
      { style: 'italic', weight: '100', file: 'Inter-ThinItalic', local: [] },
      { style: 'italic', weight: '200', file: 'Inter-ExtraLightItalic', local: [] },
      { style: 'italic', weight: '300', file: 'Inter-LightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'Inter-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'Inter-MediumItalic', local: [] },
      { style: 'italic', weight: '600', file: 'Inter-SemiBoldItalic', local: [] },
      { style: 'italic', weight: '700', file: 'Inter-BoldItalic', local: [] },
      { style: 'italic', weight: '800', file: 'Inter-ExtraBoldItalic', local: [] },
      { style: 'italic', weight: '900', file: 'Inter-BlackItalic', local: [] },
    ],
  },
  // wko
  {
    fontFamily: 'Trebuchet MS',
    fontPath: '/assets/fonts/wko/',
    fontTypes: ['woff'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'Trebuchet-MS', local: [] },
      { style: 'italic', weight: '400', file: 'Trebuchet-MS-Italic', local: [] },
      { style: 'normal', weight: '700', file: 'Trebuchet-MS-Bold', local: [] },
      { style: 'italic', weight: '700', file: 'Trebuchet-MS-Bold-Italic', local: [] },
    ],
  },
  // bosch
  {
    fontFamily: 'Bosch Sans',
    fontPath: '/assets/fonts/bosch/',
    fontTypes: ['woff2', 'woff'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'BoschSans-Light', local: [] },
      { style: 'normal', weight: '400', file: 'BoschSans-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'BoschSans-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'BoschSans-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'BoschSans-Black', local: [] },
      { style: 'italic', weight: '300', file: 'BoschSans-LightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'BoschSans-RegularItalic', local: [] },
      { style: 'italic', weight: '500', file: 'BoschSans-MediumItalic', local: [] },
      { style: 'italic', weight: '700', file: 'BoschSans-BoldItalic', local: [] },
      { style: 'italic', weight: '900', file: 'BoschSans-BlackItalic', local: [] },
    ],
  },
  // eco
  {
    fontFamily: 'Museo Sans',
    fontPath: '/assets/fonts/eco/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'MuseoSans_100', local: [] },
      { style: 'normal', weight: '300', file: 'MuseoSans_300', local: [] },
      { style: 'normal', weight: '500', file: 'MuseoSans_500', local: [] },
      { style: 'normal', weight: '700', file: 'MuseoSans_700', local: [] },
      { style: 'normal', weight: '900', file: 'MuseoSans_900', local: [] },
      { style: 'italic', weight: '100', file: 'MuseoSans_100_Italic', local: [] },
      { style: 'italic', weight: '300', file: 'MuseoSans_300_Italic', local: [] },
      { style: 'italic', weight: '500', file: 'MuseoSans_500_Italic', local: [] },
      { style: 'italic', weight: '700', file: 'MuseoSans_700_Italic', local: [] },
      { style: 'italic', weight: '900', file: 'MuseoSans_900_Italic', local: [] },
    ],
  },
  {
    // Neue Helvetica Pro 107 Condensed Extra Black
    fontFamily: 'Helvetica 107 Eco',
    fontPath: '/assets/fonts/eco/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [{ style: 'normal', weight: '900', file: 'NeueHelveticaPro_900', local: [] }],
  },
  // vodafone
  {
    fontFamily: 'Vodafone Ex',
    fontPath: '/assets/fonts/vodafone/',
    fontTypes: ['ttf'],
    fontFaces: [{ style: 'normal', weight: '900', file: 'VodafoneEx-Black', local: [] }],
  },
  {
    fontFamily: 'Vodafone Lt',
    fontPath: '/assets/fonts/vodafone/',
    fontTypes: ['ttf'],
    fontFaces: [{ style: 'normal', weight: '400', file: 'VodafoneLt-Regular', local: [] }],
  },
  {
    fontFamily: 'Vodafone Rg',
    fontPath: '/assets/fonts/vodafone/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'VodafoneRg-Regular', local: [] },
      { style: 'normal', weight: '700', file: 'VodafoneRg-Bold', local: [] },
    ],
  },
  // media group
  {
    fontFamily: 'TisaPro',
    fontPath: '/assets/fonts/media-group/TisaPro/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'TisaPro', local: [] },
      { style: 'normal', weight: '700', file: 'TisaPro-Bold', local: [] },
      { style: 'italic', weight: '400', file: 'TisaPro-Ita', local: [] },
      { style: 'italic', weight: '700', file: 'TisaPro-BoldIta', local: [] },
    ],
  },
  {
    fontFamily: 'EnzoOT',
    fontPath: '/assets/fonts/media-group/EnzoOT/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'EnzoOT-Thin', local: [] },
      { style: 'normal', weight: '300', file: 'EnzoOT-Light', local: [] },
      { style: 'normal', weight: '500', file: 'EnzoOT-Medi', local: [] },
      { style: 'normal', weight: '700', file: 'EnzoOT-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'EnzoOT-Black', local: [] },
      { style: 'italic', weight: '100', file: 'EnzoOT-ThinIta', local: [] },
      { style: 'italic', weight: '300', file: 'EnzoOT-LightIta', local: [] },
      { style: 'italic', weight: '500', file: 'EnzoOT-MediIta', local: [] },
      { style: 'italic', weight: '700', file: 'EnzoOT-BoldIta', local: [] },
      { style: 'italic', weight: '900', file: 'EnzoOT-BlackIta', local: [] },
    ],
  },
  {
    fontFamily: 'CeraPro',
    fontPath: '/assets/fonts/media-group/CeraPro/',
    fontTypes: ['woff2', 'woff', 'otf', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'Cera-Pro-Thin', local: [] },
      { style: 'normal', weight: '300', file: 'Cera-Pro-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Cera-Pro-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'Cera-Pro-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'Cera-Pro-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'Cera-Pro-Black', local: [] },
      { style: 'italic', weight: '100', file: 'Cera-Pro-Thin-Italic', local: [] },
      { style: 'italic', weight: '300', file: 'Cera-Pro-Light-Italic', local: [] },
      { style: 'italic', weight: '400', file: 'Cera-Pro-Regular-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'Cera-Pro-Medium-Italic', local: [] },
      { style: 'italic', weight: '700', file: 'Cera-Pro-Bold-Italic', local: [] },
      { style: 'italic', weight: '900', file: 'Cera-Pro-Black-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'CeraCompact',
    fontPath: '/assets/fonts/media-group/CeraCompact/',
    fontTypes: ['woff2', 'woff', 'otf', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'Cera-Compact-Pro-Thin', local: [] },
      { style: 'normal', weight: '300', file: 'Cera-Compact-Pro-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Cera-Compact-Pro-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'Cera-Compact-Pro-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'Cera-Compact-Pro-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'Cera-Compact-Pro-Black', local: [] },
      { style: 'italic', weight: '100', file: 'Cera-Compact-Pro-Thin-Italic', local: [] },
      { style: 'italic', weight: '300', file: 'Cera-Compact-Pro-Light-Italic', local: [] },
      { style: 'italic', weight: '400', file: 'Cera-Compact-Pro-Regular-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'Cera-Compact-Pro-Medium-Italic', local: [] },
      { style: 'italic', weight: '700', file: 'Cera-Compact-Pro-Bold-Italic', local: [] },
      { style: 'italic', weight: '900', file: 'Cera-Compact-Pro-Black-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'CeraCondensed',
    fontPath: '/assets/fonts/media-group/CeraCondensed/',
    fontTypes: ['woff2', 'woff', 'otf', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'Cera-Condensed-Pro-Thin', local: [] },
      { style: 'normal', weight: '300', file: 'Cera-Condensed-Pro-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Cera-Condensed-Pro-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'Cera-Condensed-Pro-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'Cera-Condensed-Pro-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'Cera-Condensed-Pro-Black', local: [] },
      { style: 'italic', weight: '100', file: 'Cera-Condensed-Pro-Thin-Italic', local: [] },
      { style: 'italic', weight: '300', file: 'Cera-Condensed-Pro-Light-Italic', local: [] },
      { style: 'italic', weight: '400', file: 'Cera-Condensed-Pro-Regular-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'Cera-Condensed-Pro-Medium-Italic', local: [] },
      { style: 'italic', weight: '700', file: 'Cera-Condensed-Pro-Bold-Italic', local: [] },
      { style: 'italic', weight: '900', file: 'Cera-Condensed-Pro-Black-Italic', local: [] },
    ],
  },
  // hagel
  {
    fontFamily: 'DIN W06',
    fontPath: '/assets/fonts/hagel/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'DIN-W06-Regular', local: [] },
      { style: 'normal', weight: '700', file: 'DIN-W06-Bold', local: [] },
    ],
  },
  // mamo
  {
    fontFamily: 'Austera Text',
    fontPath: '/assets/fonts/mamo/AusteraText/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'AusteraTextRegular', local: [] },
      { style: 'normal', weight: '700', file: 'AusteraTextBold', local: [] },
      { style: 'italic', weight: '400', file: 'AusteraTextItalic', local: [] },
      { style: 'italic', weight: '700', file: 'AusteraTextBoldItalic', local: [] },
    ],
  },
  {
    fontFamily: 'Brown',
    fontPath: '/assets/fonts/mamo/Brown/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'Brown-Light', local: [] },
      { style: 'italic', weight: '300', file: 'Brown-LightItalic', local: [] },
      { style: 'normal', weight: '400', file: 'Brown-Regular', local: [] },
      { style: 'italic', weight: '400', file: 'Brown-Italic', local: [] },
      { style: 'normal', weight: '500', file: 'Brown-Medium', local: [] },
      { style: 'italic', weight: '500', file: 'Brown-MediumItalic', local: [] },
      { style: 'normal', weight: '700', file: 'Brown-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'Brown-Heavy', local: [] },
      { style: 'normal', weight: '900', file: 'Brown-Black', local: [] },
    ],
  },
  {
    fontFamily: 'BrownCondensed',
    fontPath: '/assets/fonts/mamo/BrownCondensed/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '500', file: 'Brown-MediumCondensed', local: [] },
      { style: 'normal', weight: '700', file: 'Brown-BoldCondensed', local: [] },
      { style: 'normal', weight: '800', file: 'Brown-ExtraBoldCondensed', local: [] },
      { style: 'normal', weight: '900', file: 'Brown-BlackCondensed', local: [] },
    ],
  },
  {
    fontFamily: 'Moriston',
    fontPath: '/assets/fonts/mamo/Moriston/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'Moriston-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Moriston-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'Moriston-Medium', local: [] },
      { style: 'normal', weight: '600', file: 'Moriston-Semibold', local: [] },
      { style: 'normal', weight: '700', file: 'Moriston-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'Moriston-Black', local: [] },
    ],
  },
  // allianz
  {
    fontFamily: 'Neo W01',
    fontPath: '/assets/fonts/allianz/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'AllianzNeoW01-Light', local: [] },
      { style: 'italic', weight: '300', file: 'AllianzNeoW01-LightItalic', local: [] },
      { style: 'normal', weight: '400', file: 'AllianzNeoW01-Regular', local: [] },
      { style: 'italic', weight: '400', file: 'AllianzNeoW01-Italic', local: [] },
      { style: 'normal', weight: '600', file: 'AllianzNeoW01-SemiBold', local: [] },
      { style: 'italic', weight: '600', file: 'AllianzNeoW01-SemiBoldIt', local: [] },
      { style: 'normal', weight: '700', file: 'AllianzNeoW01-Bold', local: [] },
      { style: 'italic', weight: '700', file: 'AllianzNeoW01-BoldItalic', local: [] },
    ],
  },
  {
    fontFamily: 'Neo W02',
    fontPath: '/assets/fonts/allianz/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'AllianzNeoW02-Light', local: [] },
      { style: 'italic', weight: '300', file: 'AllianzNeoW02-LightItalic', local: [] },
      { style: 'normal', weight: '400', file: 'AllianzNeoW02-Regular', local: [] },
      { style: 'italic', weight: '400', file: 'AllianzNeoW02-Italic', local: [] },
      { style: 'normal', weight: '600', file: 'AllianzNeoW02-SemiBold', local: [] },
      { style: 'italic', weight: '600', file: 'AllianzNeoW02-SemiBoldIt', local: [] },
      { style: 'normal', weight: '700', file: 'AllianzNeoW02-Bold', local: [] },
      { style: 'italic', weight: '700', file: 'AllianzNeoW02-BoldItalic', local: [] },
    ],
  },
  {
    fontFamily: 'Neo W04',
    fontPath: '/assets/fonts/allianz/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'AllianzNeoW04-Light', local: [] },
      { style: 'italic', weight: '300', file: 'AllianzNeoW04-LightItalic', local: [] },
      { style: 'normal', weight: '400', file: 'AllianzNeoW04-Regular', local: [] },
      { style: 'italic', weight: '400', file: 'AllianzNeoW04-Italic', local: [] },
      { style: 'normal', weight: '600', file: 'AllianzNeoW04-SemiBold', local: [] },
      { style: 'italic', weight: '600', file: 'AllianzNeoW04-SemiBoldIt', local: [] },
      { style: 'normal', weight: '700', file: 'AllianzNeoW04-Bold', local: [] },
      { style: 'italic', weight: '700', file: 'AllianzNeoW04-BoldItalic', local: [] },
    ],
  },
  // medienhaus aachen
  {
    fontFamily: 'Guardian Sans',
    fontPath: '/assets/fonts/mh-aachen/GdnSans/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'GdnSans-Hairline', local: [] },
      { style: 'normal', weight: '200', file: 'GdnSans-Thin', local: [] },
      { style: 'normal', weight: '300', file: 'GdnSans-Light', local: [] },
      { style: 'normal', weight: '400', file: 'GdnSans-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'GdnSans-Medium', local: [] },
      { style: 'normal', weight: '600', file: 'GdnSans-SemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'GdnSans-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'GdnSans-Black', local: [] },
      { style: 'normal', weight: '900', file: 'GdnSans-UltraBold', local: [] },
      { style: 'italic', weight: '100', file: 'GdnSans-HairlineItalic', local: [] },
      { style: 'italic', weight: '200', file: 'GdnSans-ThinItalic', local: [] },
      { style: 'italic', weight: '300', file: 'GdnSans-LightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'GdnSans-RegularItalic', local: [] },
      { style: 'italic', weight: '500', file: 'GdnSans-MediumItalic', local: [] },
      { style: 'italic', weight: '600', file: 'GdnSans-SemiBoldItalic', local: [] },
      { style: 'italic', weight: '700', file: 'GdnSans-BoldItalic', local: [] },
      { style: 'italic', weight: '800', file: 'GdnSans-BlackItalic', local: [] },
      { style: 'italic', weight: '900', file: 'GdnSans-UltraBoldItalic', local: [] },
    ],
  },
  // gtai
  {
    fontFamily: 'Bernina Sans',
    fontPath: '/assets/fonts/gtai/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'BerninaSans-Light', local: [] },
      { style: 'normal', weight: '400', file: 'BerninaSans-Regular', local: [] },
      { style: 'normal', weight: '600', file: 'BerninaSans-Semibold', local: [] },
      { style: 'normal', weight: '700', file: 'BerninaSans-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'BerninaSans-Extrabold', local: [] },
      { style: 'italic', weight: '300', file: 'BerninaSans-LightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'BerninaSans-Italic', local: [] },
      { style: 'italic', weight: '600', file: 'BerninaSans-SemiboldItalic', local: [] },
      { style: 'italic', weight: '700', file: 'BerninaSans-BoldItalic', local: [] },
      { style: 'italic', weight: '900', file: 'BerninaSans-ExtraboldItalic', local: [] },
    ],
  },
  // wkt
  {
    fontFamily: 'DIN',
    fontPath: '/assets/fonts/wkt/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '500', file: 'DIN-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'DIN-Bold', local: [] },
    ],
  },
  // apg
  {
    fontFamily: 'Noyh',
    fontPath: '/assets/fonts/apg/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'Noyh-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Noyh-Book', local: [] },
    ],
  },
  // die medienanstalten
  {
    fontFamily: 'The Mix',
    fontPath: '/assets/fonts/medienanstalten/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'TheMixOsF-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'TheMixOsF-Light', local: [] },
      { style: 'normal', weight: '400', file: 'TheMixOsF-SemiLight', local: [] },
      { style: 'normal', weight: '500', file: 'TheMixOsF-Plain', local: [] },
      { style: 'normal', weight: '600', file: 'TheMixOsF-SemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'TheMixOsF-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'TheMixOsF-ExtraBold', local: [] },
      { style: 'normal', weight: '900', file: 'TheMixOsF-Black', local: [] },
      { style: 'italic', weight: '200', file: 'TheMixOsF-ExtraLightItalic', local: [] },
      { style: 'italic', weight: '300', file: 'TheMixOsF-LightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'TheMixOsF-SemiLightItalic', local: [] },
      { style: 'italic', weight: '500', file: 'TheMixOsF-PlainItalic', local: [] },
      { style: 'italic', weight: '600', file: 'TheMixOsF-SemiBoldItalic', local: [] },
      { style: 'italic', weight: '700', file: 'TheMixOsF-BoldItalic', local: [] },
      { style: 'italic', weight: '800', file: 'TheMixOsF-ExtraBoldItalic', local: [] },
      { style: 'italic', weight: '900', file: 'TheMixOsF-BlackItalic', local: [] },
    ],
  },
  // daehne
  {
    fontFamily: 'Graphik',
    fontPath: '/assets/fonts/daehne/graphik/',
    fontTypes: ['woff', 'woff2'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'Graphik-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'Graphik-Extralight', local: [] },
      { style: 'normal', weight: '300', file: 'Graphik-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Graphik-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'Graphik-Medium', local: [] },
      { style: 'normal', weight: '600', file: 'Graphik-Semibold', local: [] },
      { style: 'normal', weight: '700', file: 'Graphik-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'Graphik-Black', local: [] },
      { style: 'normal', weight: '900', file: 'Graphik-Super', local: [] },
      { style: 'italic', weight: '100', file: 'Graphik-ThinItalic', local: [] },
      { style: 'italic', weight: '200', file: 'Graphik-ExtralightItalic', local: [] },
      { style: 'italic', weight: '300', file: 'Graphik-LightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'Graphik-RegularItalic', local: [] },
      { style: 'italic', weight: '500', file: 'Graphik-MediumItalic', local: [] },
      { style: 'italic', weight: '600', file: 'Graphik-SemiboldItalic', local: [] },
      { style: 'italic', weight: '700', file: 'Graphik-BoldItalic', local: [] },
      { style: 'italic', weight: '800', file: 'Graphik-BlackItalic', local: [] },
      { style: 'italic', weight: '900', file: 'Graphik-SuperItalic', local: [] },
    ],
  },
  {
    fontFamily: 'Avignon',
    fontPath: '/assets/fonts/daehne/avignon/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'Avignon-Xlight', local: [] },
      { style: 'normal', weight: '400', file: 'Avignon-Book', local: [] },
      { style: 'normal', weight: '500', file: 'Avignon-Medium', local: [] },
      { style: 'normal', weight: '600', file: 'Avignon-Demi', local: [] },
      { style: 'normal', weight: '700', file: 'Avignon-Bold', local: [] },
      { style: 'italic', weight: '200', file: 'Avignon-XlightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'Avignon-BookItalic', local: [] },
      { style: 'italic', weight: '500', file: 'Avignon-MediumItalic', local: [] },
      { style: 'italic', weight: '600', file: 'Avignon-DemiItalic', local: [] },
      { style: 'italic', weight: '700', file: 'Avignon-BoldItalic', local: [] },
    ],
  },
  // allianz pro schiene
  {
    fontFamily: 'Helvetica LT Pro Condensed',
    fontPath: '/assets/fonts/allianz-pro-schiene/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'Helvetica-LT-Pro-Condensed', local: [] },
      { style: 'italic', weight: '400', file: 'Helvetica-LT-Pro-Condensed-Italic', local: [] },
      { style: 'normal', weight: '700', file: 'Helvetica-LT-Pro-Condensed-Bold', local: [] },
    ],
  },
  // mitteldeutsche zeitung
  {
    fontFamily: 'Avenir Next',
    fontPath: '/assets/fonts/mdz/AvenirNext/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'AvenirNext-UltraLight', local: [] },
      { style: 'normal', weight: '400', file: 'AvenirNext-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'AvenirNext-Medium', local: [] },
      { style: 'normal', weight: '600', file: 'AvenirNext-DemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'AvenirNext-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'AvenirNext-Heavy', local: [] },
      { style: 'italic', weight: '200', file: 'AvenirNext-UltraLightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'AvenirNext-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'AvenirNext-MediumItalic', local: [] },
      { style: 'italic', weight: '600', file: 'AvenirNext-DemiBoldItalic', local: [] },
      { style: 'italic', weight: '700', file: 'AvenirNext-BoldItalic', local: [] },
      { style: 'italic', weight: '800', file: 'AvenirNext-HeavyItalic', local: [] },
    ],
  },
  {
    fontFamily: 'Avenir Next Condensed',
    fontPath: '/assets/fonts/mdz/AvenirNextCondensed/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'AvenirNextCondensed-UltraLight', local: [] },
      { style: 'normal', weight: '400', file: 'AvenirNextCondensed-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'AvenirNextCondensed-Medium', local: [] },
      { style: 'normal', weight: '600', file: 'AvenirNextCondensed-DemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'AvenirNextCondensed-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'AvenirNextCondensed-Heavy', local: [] },
      { style: 'italic', weight: '200', file: 'AvenirNextCondensed-UltraLightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'AvenirNextCondensed-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'AvenirNextCondensed-MediumItalic', local: [] },
      { style: 'italic', weight: '600', file: 'AvenirNextCondensed-DemiBoldItalic', local: [] },
      { style: 'italic', weight: '700', file: 'AvenirNextCondensed-BoldItalic', local: [] },
      { style: 'italic', weight: '800', file: 'AvenirNextCondensed-HeavyItalic', local: [] },
    ],
  },
  {
    fontFamily: 'Domine',
    fontPath: '/assets/fonts/mdz/Domine/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'Domine-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'Domine-Medium', local: [] },
      { style: 'normal', weight: '600', file: 'Domine-SemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'Domine-Bold', local: [] },
    ],
  },
  // rheinpfalz
  {
    fontFamily: 'Maven Pro',
    fontPath: '/assets/fonts/rheinpfalz/MavenPro/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'MavenPro-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'MavenPro-Medium', local: [] },
      { style: 'normal', weight: '600', file: 'MavenPro-SemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'MavenPro-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'MavenPro-ExtraBold', local: [] },
      { style: 'normal', weight: '900', file: 'MavenPro-Black', local: [] },
    ],
  },
  // saechsische
  {
    fontFamily: 'Amplitude',
    fontPath: '/assets/fonts/saechsische/Amplitude/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'Amplitude-Light', local: [] },
      { style: 'normal', weight: '300', file: 'Amplitude-Book', local: [] },
      { style: 'normal', weight: '400', file: 'Amplitude-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'Amplitude-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'Amplitude-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'Amplitude-Black', local: [] },
      { style: 'normal', weight: '900', file: 'Amplitude-Ultra', local: [] },
    ],
  },
  {
    fontFamily: 'DIN Next',
    fontPath: '/assets/fonts/saechsische/DINNext/',
    fontTypes: ['woff2', 'woff', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'DINNextLTPro-Light', local: [] },
      { style: 'normal', weight: '400', file: 'DINNextLTPro-Regular', local: [] },
      { style: 'normal', weight: '500', file: 'DINNextLTPro-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'DINNextLTPro-Bold', local: [] },
      { style: 'italic', weight: '300', file: 'DINNextLTPro-LightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'DINNextLTPro-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'DINNextLTPro-MediumItalic', local: [] },
      { style: 'italic', weight: '700', file: 'DINNextLTPro-BoldItalic', local: [] },
    ],
  },
  {
    fontFamily: 'Myriad Pro',
    fontPath: '/assets/fonts/saechsische/MyriadPro/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'MyriadPro-Light', local: [] },
      { style: 'normal', weight: '400', file: 'MyriadPro-Regular', local: [] },
      { style: 'normal', weight: '600', file: 'MyriadPro-Semibold', local: [] },
      { style: 'normal', weight: '700', file: 'MyriadPro-Bold', local: [] },
      { style: 'normal', weight: '900', file: 'MyriadPro-Black', local: [] },
      { style: 'italic', weight: '300', file: 'MyriadPro-LightIt', local: [] },
      { style: 'italic', weight: '400', file: 'MyriadPro-It', local: [] },
      { style: 'italic', weight: '600', file: 'MyriadPro-SemiboldIt', local: [] },
      { style: 'italic', weight: '700', file: 'MyriadPro-BoldIt', local: [] },
      { style: 'italic', weight: '900', file: 'MyriadPro-BlackIt', local: [] },
    ],
  },
  {
    fontFamily: 'Roxy',
    fontPath: '/assets/fonts/saechsische/Roxy/',
    fontTypes: ['ttf', 'otf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'Roxy-Light', local: [] },
      { style: 'normal', weight: '500', file: 'Roxy-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'Roxy-Black', local: [] },
      { style: 'italic', weight: '300', file: 'Roxy-LightItalic', local: [] },
      { style: 'italic', weight: '500', file: 'Roxy-MediumItalic', local: [] },
      { style: 'italic', weight: '900', file: 'Roxy-BlackItalic', local: [] },
    ],
  },
  // yale
  {
    fontFamily: 'Mallory',
    fontPath: '/assets/fonts/yale/Mallory/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'Mallory-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'Mallory-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'Mallory-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Mallory-Book', local: [] },
      { style: 'normal', weight: '500', file: 'Mallory-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'Mallory-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'Mallory-Black', local: [] },
      { style: 'normal', weight: '900', file: 'Mallory-Ultra', local: [] },
      { style: 'italic', weight: '100', file: 'Mallory-Thin-Italic', local: [] },
      { style: 'italic', weight: '200', file: 'Mallory-ExtraLight-Italic', local: [] },
      { style: 'italic', weight: '300', file: 'Mallory-Light-Italic', local: [] },
      { style: 'italic', weight: '400', file: 'Mallory-Book-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'Mallory-Medium-Italic', local: [] },
      { style: 'italic', weight: '700', file: 'Mallory-Bold-Italic', local: [] },
      { style: 'italic', weight: '800', file: 'Mallory-Black-Italic', local: [] },
      { style: 'italic', weight: '900', file: 'Mallory-Ultra-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'Mallory Compact',
    fontPath: '/assets/fonts/yale/MalloryCompact/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'Mallory-Compact-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'Mallory-Compact-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'Mallory-Compact-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Mallory-Compact-Book', local: [] },
      { style: 'normal', weight: '500', file: 'Mallory-Compact-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'Mallory-Compact-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'Mallory-Compact-Black', local: [] },
      { style: 'normal', weight: '900', file: 'Mallory-Compact-Ultra', local: [] },
      { style: 'italic', weight: '100', file: 'Mallory-Compact-Thin-Italic', local: [] },
      { style: 'italic', weight: '200', file: 'Mallory-Compact-ExtraLight-Italic', local: [] },
      { style: 'italic', weight: '300', file: 'Mallory-Compact-Light-Italic', local: [] },
      { style: 'italic', weight: '400', file: 'Mallory-Compact-Book-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'Mallory-Compact-Medium-Italic', local: [] },
      { style: 'italic', weight: '700', file: 'Mallory-Compact-Bold-Italic', local: [] },
      { style: 'italic', weight: '800', file: 'Mallory-Compact-Black-Italic', local: [] },
      { style: 'italic', weight: '900', file: 'Mallory-Compact-Ultra-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'Mallory Condensed',
    fontPath: '/assets/fonts/yale/MalloryCondensed/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'Mallory-Condensed-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'Mallory-Condensed-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'Mallory-Condensed-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Mallory-Condensed-Book', local: [] },
      { style: 'normal', weight: '500', file: 'Mallory-Condensed-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'Mallory-Condensed-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'Mallory-Condensed-Black', local: [] },
      { style: 'normal', weight: '900', file: 'Mallory-Condensed-Ultra', local: [] },
      { style: 'italic', weight: '100', file: 'Mallory-Condensed-Thin-Italic', local: [] },
      { style: 'italic', weight: '200', file: 'Mallory-Condensed-ExtraLight-Italic', local: [] },
      { style: 'italic', weight: '300', file: 'Mallory-Condensed-Light-Italic', local: [] },
      { style: 'italic', weight: '400', file: 'Mallory-Condensed-Book-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'Mallory-Condensed-Medium-Italic', local: [] },
      { style: 'italic', weight: '700', file: 'Mallory-Condensed-Bold-Italic', local: [] },
      { style: 'italic', weight: '800', file: 'Mallory-Condensed-Black-Italic', local: [] },
      { style: 'italic', weight: '900', file: 'Mallory-Condensed-Ultra-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'Mallory Extra Condensed',
    fontPath: '/assets/fonts/yale/MalloryExtraCondensed/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'Mallory-ExtraCondensed-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'Mallory-ExtraCondensed-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'Mallory-ExtraCondensed-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Mallory-ExtraCondensed-Book', local: [] },
      { style: 'normal', weight: '500', file: 'Mallory-ExtraCondensed-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'Mallory-ExtraCondensed-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'Mallory-ExtraCondensed-Black', local: [] },
      { style: 'normal', weight: '900', file: 'Mallory-ExtraCondensed-Ultra', local: [] },
      { style: 'italic', weight: '100', file: 'Mallory-ExtraCondensed-Thin-Italic', local: [] },
      { style: 'italic', weight: '200', file: 'Mallory-ExtraCondensed-ExtraLight-Italic', local: [] },
      { style: 'italic', weight: '300', file: 'Mallory-ExtraCondensed-Light-Italic', local: [] },
      { style: 'italic', weight: '400', file: 'Mallory-ExtraCondensed-Book-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'Mallory-ExtraCondensed-Medium-Italic', local: [] },
      { style: 'italic', weight: '700', file: 'Mallory-ExtraCondensed-Bold-Italic', local: [] },
      { style: 'italic', weight: '800', file: 'Mallory-ExtraCondensed-Black-Italic', local: [] },
      { style: 'italic', weight: '900', file: 'Mallory-ExtraCondensed-Ultra-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'Mallory Narrow',
    fontPath: '/assets/fonts/yale/MalloryNarrow/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '100', file: 'Mallory-Narrow-Thin', local: [] },
      { style: 'normal', weight: '200', file: 'Mallory-Narrow-ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'Mallory-Narrow-Light', local: [] },
      { style: 'normal', weight: '400', file: 'Mallory-Narrow-Book', local: [] },
      { style: 'normal', weight: '500', file: 'Mallory-Narrow-Medium', local: [] },
      { style: 'normal', weight: '700', file: 'Mallory-Narrow-Bold', local: [] },
      { style: 'normal', weight: '800', file: 'Mallory-Narrow-Black', local: [] },
      { style: 'normal', weight: '900', file: 'Mallory-Narrow-Ultra', local: [] },
      { style: 'italic', weight: '100', file: 'Mallory-Narrow-Thin-Italic', local: [] },
      { style: 'italic', weight: '200', file: 'Mallory-Narrow-ExtraLight-Italic', local: [] },
      { style: 'italic', weight: '300', file: 'Mallory-Narrow-Light-Italic', local: [] },
      { style: 'italic', weight: '400', file: 'Mallory-Narrow-Book-Italic', local: [] },
      { style: 'italic', weight: '500', file: 'Mallory-Narrow-Medium-Italic', local: [] },
      { style: 'italic', weight: '700', file: 'Mallory-Narrow-Bold-Italic', local: [] },
      { style: 'italic', weight: '800', file: 'Mallory-Narrow-Black-Italic', local: [] },
      { style: 'italic', weight: '900', file: 'Mallory-Narrow-Ultra-Italic', local: [] },
    ],
  },
  {
    fontFamily: 'Yale New',
    fontPath: '/assets/fonts/yale/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'YaleNew-Roman', local: [] },
      { style: 'normal', weight: '700', file: 'YaleNew-Bold', local: [] },
      { style: 'italic', weight: '400', file: 'YaleNew-Italic', local: [] },
      { style: 'italic', weight: '700', file: 'YaleNew-BoldItalic', local: [] },
    ],
  },
  {
    fontFamily: 'The Sans C4s',
    fontPath: '/assets/fonts/br/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '200', file: 'TheSansC4s-2_ExtraLight', local: [] },
      { style: 'normal', weight: '300', file: 'TheSansC4s-3_Light', local: [] },
      { style: 'normal', weight: '400', file: 'TheSansC4s-4_SemiLight', local: [] },
      { style: 'normal', weight: '500', file: 'TheSansC4s-5_Plain', local: [] },
      { style: 'normal', weight: '600', file: 'TheSansC4s-6_SemiBold', local: [] },
      { style: 'normal', weight: '700', file: 'TheSansC4s-7_Bold', local: [] },
      { style: 'normal', weight: '800', file: 'TheSansC4s-8_ExtraBold', local: [] },
      { style: 'normal', weight: '900', file: 'TheSansC4s-9_Black', local: [] },
      { style: 'italic', weight: '200', file: 'TheSansC4s-2iExtraLightIta', local: [] },
      { style: 'italic', weight: '300', file: 'TheSansC4s-3iLightItalic', local: [] },
      { style: 'italic', weight: '400', file: 'TheSansC4s-4iSemiLightIta', local: [] },
      { style: 'italic', weight: '500', file: 'TheSansC4s-5iPlainItalic', local: [] },
      { style: 'italic', weight: '600', file: 'TheSansC4s-6iSemiBoldIta', local: [] },
      { style: 'italic', weight: '700', file: 'TheSansC4s-7iBoldItalic', local: [] },
      { style: 'italic', weight: '800', file: 'TheSansC4s-8iExtraBoldIta', local: [] },
      { style: 'italic', weight: '900', file: 'TheSansC4s-9iBlackItalic', local: [] },
    ],
  },
  // rheinische-post
  {
    fontFamily: 'GdnSans',
    fontPath: '/assets/fonts/rheinische-post/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'GdnSans', local: [] },
      { style: 'normal', weight: '700', file: 'GDNSANS-BOLD', local: [] },
    ],
  },
  {
    fontFamily: 'Guardian Sans PS',
    fontPath: '/assets/fonts/rheinische-post/',
    fontTypes: ['ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'GuardianSansPS-Regular', local: [] },
      { style: 'normal', weight: '700', file: 'GuardianSansPS-Bold', local: [] },
    ],
  },
  // mgo
  {
    fontFamily: 'Helvetica Neue LT Std',
    fontPath: '/assets/fonts/mgo/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'HelveticaNeueLTStd-Cn', local: [] },
      { style: 'normal', weight: '700', file: 'HelveticaNeueLTStd-BdCn', local: [] },
    ],
  },
  // hays
  {
    fontFamily: 'Saans Hays',
    fontPath: '/assets/fonts/hays/',
    fontTypes: ['woff2', 'woff', 'ttf', 'otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'SaansHays-Regular', local: [] },
      { style: 'normal', weight: '600', file: 'SaansHays-SemiBold', local: [] },
      { style: 'italic', weight: '400', file: 'SaansHays-RegularItalic', local: [] },
    ],
  },
  // wn
  {
    fontFamily: 'Frutiger Next',
    fontPath: '/assets/fonts/wn/',
    fontTypes: ['woff2', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '300', file: 'FrutigerNextCom-Light', local: [] },
      { style: 'normal', weight: '400', file: 'FrutigerNextCom-Regular', local: [] },
      { style: 'normal', weight: '700', file: 'FrutigerNextCom-Bold', local: [] },
    ],
  },
  {
    fontFamily: 'Frutiger Next Condensed',
    fontPath: '/assets/fonts/wn/',
    fontTypes: ['woff2', 'ttf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'FrutigerNextCom-RegularCn', local: [] },
      { style: 'normal', weight: '600', file: 'FrutigerNextCom-MediumCn', local: [] },
      { style: 'normal', weight: '700', file: 'FrutigerNextCom-BoldCn', local: [] },
      { style: 'normal', weight: '800', file: 'FrutigerNextCom-HeavyCn', local: [] },
    ],
  },
  // acatech
  {
    fontFamily: 'Quay Sans ITC Std',
    fontPath: '/assets/fonts/acatech/',
    fontTypes: ['otf'],
    fontFaces: [
      { style: 'normal', weight: '400', file: 'QuaySansITCStd-Book', local: [] },
      { style: 'normal', weight: '600', file: 'QuaySansITCStd-Medium', local: [] },
      { style: 'normal', weight: '900', file: 'QuaySansITCStd-Black', local: [] },
      { style: 'italic', weight: '400', file: 'QuaySansITCStd-BookItalic', local: [] },
      { style: 'italic', weight: '600', file: 'QuaySansITCStd-MediumItalic', local: [] },
      { style: 'italic', weight: '900', file: 'QuaySansITCStd-BlackItalic', local: [] },
    ],
  },
];

export { POSSIBLE_FONT_WEIGHT_OPTIONS, FONT_CONFIG };
